<template>
  <div>
    <v-app>
      <Home />
    </v-app>
  </div>
</template>

<script>
import Home from "./components/Home";

export default {
  name: "App",
  components: {
    Home,
  },
};
</script>
<style lang="scss" scoped>
@use 'components/sharedSCSS/globalSharedVariables';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  background: #f7f7f7;
}

a {
  text-decoration: none;
  color: globalSharedVariables.$brand-700;

  &:hover {
    color: globalSharedVariables.$brand-800;
  }

  &:disabled {
    color: globalSharedVariables.$grey-300;
  }
}

header {
  width: 100dvw;
  background-color: #f7f7f7;
  padding: 15px;
  border-bottom: 3px solid transparent;
}

router-view {
  width: 100%;
  height: 100%;
  top: 5px;
  left: 0px;
  background-color: #ffffff !important;
  padding: 10px;
  overflow: hidden;
  visibility: visible;
  display: block;
  z-index: 500 !important;
  position: relative;
}
</style>
